import { FC, useEffect, useState } from 'react';
import EditIcon from '@material-ui/icons/Edit';
import { injectIntl, IntlShape } from 'react-intl';
import { Grid, Chip, Tooltip } from '@material-ui/core';
import { isEmpty, get, isNil } from 'lodash';
import Link from '@material-ui/core/Link';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';
import messages from 'containers/CourtManagerLegalProceedings/messages';
import { translate } from 'containers/services/translate';
import { COLORS } from 'constants/design';

import { GridWrapper } from 'containers/PreOpeningPage/ClaimInformation/style';
import {
  StyledGrid,
  Title,
  Title2,
  Title3,
  OpenInNewIcon,
  StyledCard,
  StyledCardContent,
} from 'containers/CourtManagerLegalProceedings/styled-components';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';
import userPrivileges, {
  PRIVILEGES,
} from 'containers/services/security/user-privileges';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import {
  getNextAvailableStatuses,
  renderColor,
} from 'containers/CourtManagerLegalProceedings/utils';
import {
  CLAIM_STATUSES,
  CLAIM_STATUS_OPERATIONS,
} from 'containers/CourtManagerLegalProceedings/constants';
import {
  getProvisionInfo,
  sumValue,
} from 'containers/CourtManagerLegalProceedings/Provision/utils';
import { SagisConfig } from 'containers/AppContainer/typings';
import docIcon from 'images/doc-icon.svg';
import TrackingIcon from 'images/trackingIcon.svg';
import {
  StyledContainer,
  StyledElement,
  StyledIcon,
  StyledChip,
  StyledPinIcon,
  StyledOrangeChip,
} from 'containers/CourtManagerLegalProceedings/TopCard/style';
import { useHistory } from 'react-router';
import StarIcon from '@material-ui/icons/Star';
import StatusDialog from 'containers/CourtManagerLegalProceedings/TopCard/statusDialog';
import { toast } from 'react-toastify';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { STATUS_VALIDATED } from 'containers/LawyerFeeNote/constants';
import { CLAIM_STATUS } from 'containers/data-structure';
import { ClaimRecapType } from 'typings/claimTypes';

export interface TopCardProps {
  claimRecap: ClaimRecapType;
  inputProps: any;
  intl: IntlShape;
  handleOpenCivilProceeding: Function;
  handleOpenDisclaimerWarrantyReasons: Function;
  toggleDrawer: Function;
  requestSagisClaimInfo: Function;
  setDropDown: any;
  dropDown: any;
  sagisClaim: any;
  claimNumber: string;
  judiciaryProcess?: any;
  intervenants?: SagisConfig[];
  toggleDrawerAssignmentClaim: Function;
  toggleAddVictimCard: Function;
  assignedLawyer: any;
  setIsAssignmentDialogOpen: Function;
  setOpenIsSuspiciosClaimDialog: Function;
  handleToggleImagineDocDrawer: Function;
  resetSagisInfoClaim: Function;
  claimHasCivilPartyJudiciaryProcess: any;
  handleToggleTrackingDrawer: Function;
  requestSetStatusClaimSagis: Function;
  isConsultation: boolean;
  isAllDisabled?: boolean;
  handleResetStore: Function;
  listings: any;
  shouldHideActionButton?: boolean;
}

export const TopCard: FC<TopCardProps> = props => {
  const { sagisClaim, claimNumber } = props;
  const provisionInfo = getProvisionInfo(sagisClaim);
  const history = useHistory();
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [claimStatus, setClaimStatus] = useState(null);
  const [reasonCode, setReasonCode] = useState(null);

  useEffect(() => {
    if (
      !isEmpty(claimNumber) &&
      get(props.claimRecap, 'claim.status') === STATUS_VALIDATED
    ) {
      props.requestSagisClaimInfo(claimNumber);
    }
    history.listen(() => {
      props.resetSagisInfoClaim();
    });
  }, [claimNumber]);
  const commonElement = [
    {
      title: translate(messages.civilProceeding, props),
      action: props.handleOpenCivilProceeding(2),
    },
    {
      title: translate(messages.commercialProceeding, props),
      action: props.handleOpenCivilProceeding(1),
    },
  ];
  const commonDropDownMenuElements = [
    ...commonElement,
    {
      title: translate(messages.creation, props),
      action: pushTo(PAGES.MANAGER_FEE_NOTE),
    },
    {
      title: translate(messages.ExlusionOfWarranty, props),
      action: props.handleOpenDisclaimerWarrantyReasons,
    },
  ];
  const transactionDropDownMenuElements = [
    {
      title: translate(messages.creation, props),
      action: pushTo(PAGES.TRANSACTION_MANAGER_FEE_NOTE),
    },
    {
      title: translate(messages.ExlusionOfWarranty, props),
      action: props.handleOpenDisclaimerWarrantyReasons,
    },
  ];

  let dropDownMenuElements = (featureService.hasFeature(
    FEATURES.EVOLUTION_P4,
  ) && !userPrivileges.userHasPrivilege(PRIVILEGES.ISTRANSACTIONMANAGER)
  ? true
  : userPrivileges.userHasPrivilege(PRIVILEGES.ISMANAGER) &&
    !userPrivileges.userHasPrivilege(PRIVILEGES.ISTRANSACTIONMANAGER))
    ? [
        ...commonDropDownMenuElements,
        {
          title: translate(messages.addVictim, props),
          action: props.toggleAddVictimCard,
        },
      ]
    : userPrivileges.userHasPrivilege(PRIVILEGES.ISTRANSACTIONMANAGER)
    ? [...transactionDropDownMenuElements]
    : commonDropDownMenuElements;

  dropDownMenuElements = !featureService.hasFeature(FEATURES.FRAUD_INFO)
    ? [
        ...dropDownMenuElements,
        {
          title: translate(messages.suspiciousClaimTitle, props),
          action: props.setOpenIsSuspiciosClaimDialog,
        },
      ]
    : [...dropDownMenuElements];

  const monitoringManager = [
    ...commonElement,
    {
      title: translate(messages.AssignExpertTitle, props),
      action: () => props.toggleDrawer(),
      titleTooltip: !props.assignedLawyer
        ? translate(messages.monitoringManagerDisabledTitle, props)
        : !get(
            props.claimHasCivilPartyJudiciaryProcess,
            'hasCivilParty',
            true,
          ) &&
          !get(
            props.claimHasCivilPartyJudiciaryProcess,
            'hasJudiciaryProcessRequest',
            true,
          )
        ? translate(messages.disableCreateMission, props)
        : null,
      disabled: props.assignedLawyer
        ? !get(
            props.claimHasCivilPartyJudiciaryProcess,
            'hasCivilParty',
            true,
          ) &&
          !get(
            props.claimHasCivilPartyJudiciaryProcess,
            'hasJudiciaryProcessRequest',
            true,
          )
          ? true
          : false
        : true,
    },
  ];

  const successCallBack = () => {
    setOpenStatusDialog(false);
    toast.success(translate(messages.successUpdateStatusTitle, props));
    if (claimStatus === CLAIM_STATUSES.REOPEN) {
      props.handleResetStore();
      userPrivileges.userHasPrivilege(PRIVILEGES.ISCOURTMONITORINGMANAGER)
        ? pushTo(
            `${PAGES.COURT_MONITORING_MANAGER_LEGAL_PROCEEDINGS}/${get(
              props.claimRecap,
              'claim.id',
              null,
            )}`,
          )()
        : userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)
        ? pushTo(
            `${PAGES.MANAGER_RECAP_PAGE}/${get(
              props.claimRecap,
              'claim.id',
              null,
            )}`,
          )()
        : pushTo(
            `${PAGES.COURT_MANAGER_LEGAL_PROCEEDINGS}/${get(
              props.claimRecap,
              'claim.id',
              null,
            )}`,
          )();
    } else if (
      claimStatus === CLAIM_STATUSES.NOFOLLOWUP ||
      claimStatus === CLAIM_STATUSES.CLOSED
    ) {
      props.handleResetStore();
      userPrivileges.userHasPrivilege(PRIVILEGES.ISOPENINGMANAGER)
        ? pushTo(
            `${PAGES.CONSULATION_OPENING_PAGE}/${get(
              props.claimRecap,
              'claim.id',
              null,
            )}`,
          )()
        : pushTo(
            `${PAGES.CONSULTATION_LEGAL_PROCEEDING_PAGE}/${get(
              props.claimRecap,
              'claim.id',
              null,
            )}`,
          )();
    }
  };

  const handleValidateStatusDialog = () => {
    props.requestSetStatusClaimSagis(
      {
        claimNumber: claimNumber,
        claimId: get(props.claimRecap, 'claim.id', null),
        updatedBy: currentUserStorage.get().username,
        isTrackingActive: featureService.hasFeature(
          FEATURES.TRACKING_ACTIONS_USER,
        ),
        isNoFollowUpStatus: claimStatus === CLAIM_STATUSES.NOFOLLOWUP,
        reasonCode: reasonCode,
        operation: !isNil(claimStatus)
          ? //@ts-ignore
            get(CLAIM_STATUS_OPERATIONS, claimStatus)
          : '',
      },
      successCallBack,
    );
  };
  return (
    <>
      <StyledCard>
        <StyledCardContent>
          <Grid
            container
            direction="row"
            alignItems={'center'}
            style={{ marginTop: 20 }}
          >
            <Title gutterBottom>
              {translate({ ...messages.claimNumber }, props) +
                '   ' +
                claimNumber}
            </Title>
            {(featureService.hasFeature(FEATURES.BASIC_MANAGEMENT_REGULATION) ||
              featureService.hasFeature(FEATURES.BASIC_MANAGEMENT)) &&
              get(props.claimRecap, 'claim.isBasicManagement', false) && (
                <Chip
                  style={StyledOrangeChip}
                  className="primary"
                  label={translate(messages.basicManagementTitle, props)}
                />
              )}
            {featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
              !isNil(get(props.claimRecap, 'claim.priorityReasonId', null)) && (
                <Tooltip
                  style={{
                    cursor: 'pointer',
                    width: '20px',
                    height: '20px',
                  }}
                  placement="top"
                  arrow
                  title={get(
                    props.claimRecap,
                    'claim.priorityClaimReason.title',
                    null,
                  )}
                >
                  <StarIcon
                    style={{
                      color: '#ffcd3c',
                      width: 30,
                      height: 30,
                      borderColor: '#ffcd3c',
                    }}
                  />
                </Tooltip>
              )}
            {featureService.hasFeature(FEATURES.STATUS_MANAGEMENT) &&
              !isNil(get(sagisClaim, 'status', null)) && (
                <Grid item>
                  <Grid
                    container
                    direction="row"
                    alignItems={'center'}
                    spacing={1}
                  >
                    <Grid item xs>
                      <Chip
                        style={StyledChip}
                        className="primary"
                        label={get(sagisClaim, 'status', null)}
                      />
                    </Grid>
                    {!props.isAllDisabled &&
                      get(props.claimRecap, 'claim.status') ===
                        CLAIM_STATUS.VALIDATED && (
                        <Grid item>
                          <div
                            data-testid="edit-icon"
                            onClick={() => setOpenStatusDialog(true)}
                          >
                            <EditIcon style={StyledPinIcon} />
                          </div>
                        </Grid>
                      )}
                  </Grid>
                </Grid>
              )}
            {featureService.hasFeature(FEATURES.CLAIM_NATURE_TRANSACTION) &&
              !isNil(get(props.claimRecap, 'claim.claimNatureId', null)) && (
                <Grid item>
                  <Chip
                    style={{
                      backgroundColor: renderColor(
                        get(props.claimRecap, 'claim.claimNature.title', null),
                      ),
                      color: COLORS.WHITE,
                      fontWeight: 700,
                      borderColor: renderColor(
                        get(props.claimRecap, 'claim.claimNature.title', null),
                      ),
                      borderWidth: 1,
                      marginLeft: 10,
                    }}
                    label={get(
                      props.claimRecap,
                      'claim.claimNature.title',
                      null,
                    )}
                  />
                </Grid>
              )}
          </Grid>

          <GridWrapper>
            <Grid container>
              <Grid item xs={2}>
                <Title2 gutterBottom>
                  {translate({ ...messages.provision }, props)}
                </Title2>
                <Title3 gutterBottom>
                  {!isEmpty(provisionInfo) &&
                    sumValue(
                      provisionInfo.map((item: any) =>
                        parseFloat(item?.provision),
                      ),
                    ).toFixed(2) + ' DH '}
                  {!props.isConsultation && (
                    <Link href="">
                      <OpenInNewIcon fontSize={'small'} />
                    </Link>
                  )}
                </Title3>
              </Grid>
              <Grid item xs={2}>
                <Title2 gutterBottom>
                  {translate({ ...messages.reglement }, props)}
                </Title2>
                <Title3 gutterBottom>
                  {!isEmpty(provisionInfo)
                    ? `${sumValue(
                        provisionInfo.map((item: any) =>
                          parseFloat(item?.regulation),
                        ),
                      ).toFixed(2)} DH`
                    : '0.0'}
                  {!props.isConsultation && (
                    <Link href="">
                      <OpenInNewIcon fontSize={'small'} />
                    </Link>
                  )}
                </Title3>
              </Grid>
              <Grid item xs={2}>
                <Title2 gutterBottom>
                  {translate({ ...messages.recours }, props)}
                </Title2>
                <Title3 gutterBottom>
                  {'- DH '}
                  {!props.isConsultation && (
                    <Link href="">
                      <OpenInNewIcon fontSize={'small'} />
                    </Link>
                  )}
                </Title3>
              </Grid>
              <Grid item xs={2}>
                <Title2 gutterBottom>
                  {translate({ ...messages.companyCost }, props)}
                </Title2>
                <Title3 gutterBottom>
                  {(sagisClaim && sagisClaim.companyCost
                    ? sagisClaim.companyCost
                    : '00.00') + ' DH'}
                </Title3>
              </Grid>
              {featureService.hasFeature(FEATURES.TRAITEMENT_IMAGINE_DOC) && (
                <Grid item>
                  <Grid
                    style={StyledContainer}
                    container
                    direction="row"
                    alignItems="center"
                    onClick={() => props.handleToggleImagineDocDrawer()}
                  >
                    <Grid item>
                      <img src={docIcon} alt="doc icon" />
                    </Grid>
                    <Grid item style={StyledElement}>
                      {translate({ ...messages.topCardDocTitle }, props)}
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {!props.isConsultation && !props.shouldHideActionButton && (
                <Grid item>
                  <StyledGrid>
                    <DropDownDecisionMenu
                      setDropDown={props.setDropDown}
                      dropDown={props.dropDown}
                      label={translate(messages.managerActionTitle, props)}
                      menuElements={
                        userPrivileges.userHasPrivilege(
                          PRIVILEGES.ISCOURTMONITORINGMANAGER,
                        )
                          ? monitoringManager
                          : dropDownMenuElements
                      }
                    />
                  </StyledGrid>
                </Grid>
              )}
              {featureService.hasFeature(FEATURES.DISPLAY_TRACKING_ICON) && (
                <Grid item>
                  <img
                    src={TrackingIcon}
                    style={StyledIcon}
                    alt="track"
                    onClick={() => props.handleToggleTrackingDrawer()}
                  />
                </Grid>
              )}
              {featureService.hasFeature(FEATURES.STATUS_MANAGEMENT) && (
                <StatusDialog
                  open={openStatusDialog}
                  onClose={() => setOpenStatusDialog(false)}
                  status={(claimStatus as unknown) as string}
                  setStatus={setClaimStatus}
                  validateDialog={handleValidateStatusDialog}
                  availableStatus={getNextAvailableStatuses(
                    get(sagisClaim, 'status', ''),
                  )}
                  reasonCode={reasonCode}
                  setReasonCode={setReasonCode}
                  listings={props.listings}
                />
              )}
            </Grid>
          </GridWrapper>
        </StyledCardContent>
      </StyledCard>
    </>
  );
};

export default injectIntl(TopCard);
